<script lang="ts" setup>
import { computed } from 'vue';
import { useEstimatedDate } from '@client/monolith/core/composables/use-estimated-date';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  minDays?: number | null;
  maxDays?: number | null;
  isFastDelivery?: boolean;
}>();

const { getFormattedEstimatedDate } = useEstimatedDate();

const { t } = useI18n();

const formattedEstimatedDeliveryDays = computed(() => {
  if (!props.minDays || !props.maxDays) {
    return null;
  } else {
    return getFormattedEstimatedDate(props.minDays, props.maxDays);
  }
});
</script>

<template>
  <div
    v-if="minDays !== null && maxDays !== null"
    class="card-product-estimated-delivery"
  >
    <div
      v-if="formattedEstimatedDeliveryDays"
      class="delivery-date-label"
      data-testid="deliveryDateLabel"
      :class="{ 'delivery-date-label--fast': isFastDelivery }"
    >
      <AkIcon
        :symbol="isFastDelivery ? 'truck-fast' : 'truck'"
        class="delivery-date-label__icon"
        data-testid="deliveryDateLabelIcon"
      />
      <i18n-t
        tag="p"
        keypath="product.estimatedDateDelivery.label"
      >
        <template #initialMessage>
          <span class="delivery-date-label__label">{{ t('product.estimatedDateDelivery.initialMessage') }}</span>
        </template>
        <template #date>
          <span
            class="delivery-date-label__date"
            data-testid="deliveryDateLabelDate"
          >{{ formattedEstimatedDeliveryDays }}</span>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-product-estimated-delivery {
  @apply ds-mt-auto;
}
.delivery-date-label {
  @apply ds-flex ds-gap-1 ds-text-neutral-900 ds-text-sm ds-mt-auto ds-items-center;
  min-height: 1lh;
  &__label {
    @apply ds-hidden md:ds-inline-block;
  }
  &__date {
    @apply ds-font-bold;
  }
  :deep(.delivery-date-label__icon) {
    @apply ds-text-base;
  }
  &--fast {
    .delivery-date-label {
      &__icon,
      &__date {
        @apply ds-text-info-700;
      }
    }
  }
}
</style>
